import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { UserTip } from '../map.component';
import {
  CHARTS,
  LENSES,
  LEVEL_SELECTION,
  MAPS,
  RADIUS_SELECTION,
  SEARCH,
} from './hint-utility';
import { BreakpointObserverService } from '../../shared/services/breakpoint-observer.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgClass, NgIf } from '@angular/common';

export const GUIDE_COMPLETED = 'GUIDE_COMPLETED';

@Component({
  selector: 'app-popup-hint',
  templateUrl: './popup-hint.component.html',
  styleUrls: ['./popup-hint.component.scss'],
  imports: [NgClass, NgIf],
})
export class PopupHintComponent implements OnInit, AfterViewInit {
  @Output() closePopup = new EventEmitter();

  public title!: string;
  public cssClass!: string;
  public textContent!: string;
  public closable!: boolean;

  constructor(
    public dialogRef: MatDialogRef<PopupHintComponent>,
    private el: ElementRef,
    private renderer: Renderer2,
    private breakpointObserverService: BreakpointObserverService,
    @Inject(MAT_DIALOG_DATA) public data: UserTip
  ) {
    this.title = data.title;
    this.cssClass = data.cssClass;
    this.textContent = data.textContent;
    this.closable = data.closable;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.setArrowLocation(this.title);
  }

  private setArrowLocation(title: string): void {
    const container = this.el.nativeElement.querySelector('.popup-container');
    const arrowPointer = this.el.nativeElement.querySelector('.arrow-pointer');

    const rect: DOMRect = container.getBoundingClientRect();

    if (this.breakpointObserverService.isMobile.getValue()) {
      if (title === SEARCH) {
        this.renderer.setStyle(arrowPointer, 'top', `-20px`);
        this.renderer.setStyle(arrowPointer, 'left', `15px`);
        this.renderer.setStyle(arrowPointer, 'transform', 'rotate(270deg)');
      } else if (title === MAPS || title === LEVEL_SELECTION) {
        this.renderer.setStyle(arrowPointer, 'top', `-20px`);
        this.renderer.setStyle(arrowPointer, 'left', `155px`);
      }
    } else if (!this.breakpointObserverService.isMobile.getValue()) {
      if (
        title === SEARCH ||
        title === RADIUS_SELECTION ||
        title === LEVEL_SELECTION
      ) {
        this.renderer.setStyle(arrowPointer, 'top', `-20px`);
        this.renderer.setStyle(arrowPointer, 'left', `15px`);
      } else if (title === MAPS || title === CHARTS || title === LENSES) {
        this.renderer.setStyle(arrowPointer, 'left', `auto`);
        this.renderer.setStyle(arrowPointer, 'top', `15px`);
        this.renderer.setStyle(arrowPointer, 'right', `-20px`);
      }
    }
  }

  public handleClose(): void {
    this.dialogRef.close();
  }

  public handleDontShowAgain(): void {
    localStorage.setItem(GUIDE_COMPLETED, 'true');
    this.dialogRef.close();
  }
}
